module.exports = __webpack_public_path__ + "static/media/bannerMobile.73062620.svg";